import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { ILoggerService } from '../../services';
import { toggleMaximizeWidget, editGroupWidgetShapeState, editWidgetShapeState } from '../../common';

class WidgetPanelController implements angular.IComponentController {
    isLoading: boolean;
    isOutsideWindow: boolean = false;
    item: any;
    itemGuid: string;
    loadingMessage: string;
    maximized: string;
    saveTitle: string;
    showPin: boolean;
    targetPin: string;

    private _garbages: (() => void)[] = [];

    static $inject = [
        '$scope',
        '$rootScope',
        '$state',
        'loggerService'
    ];

    constructor(private _$scope: angular.IScope,
        private _$rootScope: angular.IRootScopeService,
        private _$state: angular.ui.IStateService,
        private _loggerService: ILoggerService) {
    }

    $onInit() {
        this.saveTitle = 'Save in a dashboard';

        this._garbages.push(this._$scope.$watch(() => this.item, () => {
            if (this.maximized && this.maximized !== 'false' && this.item && !this.item.isDisabledMaximized) {
                this.item.isMaximized = true;
                this.isOutsideWindow = true;
                this._$rootScope.$broadcast(toggleMaximizeWidget, { isMaximized: this.item.isMaximized });
            }
        }));
    }

    $onDestroy() {
        this._garbages.forEach(g => g());
    }

    exportToCsv(): void {
        this.isLoading = true;
        this.loadingMessage = 'Exporting data to csv.';

        this.item.exportToCsv()
            .catch(() => {
                this._loggerService.logError('Could not export data to csv.');
            }).finally(() => {
                this.isLoading = false;
            });
    }

    getPinTitle(): string {
        return (this.item.isPinned)
            ? (this.item.isPinWarning)
                ? 'The trend has been modified. Click to update'
                : 'Remove from favorites'
            : 'Add to favorites';
    }

    getPinTarget(): string {
        return ((this.item.isPinned && !this.item.isPinWarning) ? 'un' : '') + `pin${this.targetPin}`;
    }

    watchKeyPress($event) {
        if ($event.keyCode === 27) {
            if (this.item.isMaximized && !this.item.isDisabledMaximized) {
                this.item.isMaximized = false;
                $event.preventDefault();
            }
        }
    }

    goShapes() {
        const route = this._$state.params['groupGuid']
            ? editGroupWidgetShapeState
            : editWidgetShapeState;

        this._$state.go(route, this._$state.params);
    }
}

export const wtWidgetPanel: ComponentDefinition = {
    componentId: 'wtWidgetPanel',
    controller: WidgetPanelController,
    template: require('./widgetPanel.component.html'),
    transclude: true,
    controllerAs: 'vm',
    bindings: {
        applicationGuid: '<?',
        cancel: '&?',
        canEdit: '&',
        editedItem: '=',
        isError: '=',
        isSelected: '&',
        isWarning: '=',
        item: '=',
        itemGuid: '<?',
        load: '&',
        maximized: '<?',
        saveTitle: '@',
        showPin: '=?',
        target: '@',
        targetPin: '@',
    }
};
